import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, EMPTY, filter, map, Observable, of, ReplaySubject, Subscription, switchMap, take, tap } from 'rxjs';
import { CurrentEventsService, GetUsersFromCompany200ResponseInner, ItemResource, UserService as UserApiService } from '../api';
import {
    UserResource,
    AuthorizationService,
    RoleService,
    AuthorizationPasswordService,
    AssignRoleToUserRequest,
    ResetPasswordRequest,
    ResetUserPasswordRequest,
} from '../api';

@Injectable({
    providedIn: 'root',
})
export class NewsService {
    private _currentEvent = new BehaviorSubject<any | null>(null);
    private _currentEvents: BehaviorSubject<ItemResource[] | null> = new BehaviorSubject<ItemResource[] | null>(null);
    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private readonly _accessService: AuthorizationService,
        private readonly userApiService: UserApiService,
        private _roleService: RoleService,
        private _authPassService: AuthorizationPasswordService,
        private readonly currentEventsDsService: CurrentEventsService,
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set currentEvent(value: any | null) {
        // Store the value
        this._currentEvent.next(value);
    }

    get currentEvent$(): Observable<any | null> {
        return this._currentEvent.asObservable().pipe(
            switchMap((currentEvent: any | null) => {
                if (!currentEvent) {
                    return this.get().pipe(tap((newCurrentEvent: any) => this._currentEvent.next(newCurrentEvent)));
                }
                return of(currentEvent);
            }),
        );
    }

    get currentEvents$(): Observable<ItemResource[] | null> {
        return this._currentEvents.asObservable().pipe(
            switchMap((currentEvents: ItemResource[] | null) => {
                if (!currentEvents) {
                    return this.getCurrentEvents();
                }
                return of(currentEvents);
            }),
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    public getCurrentEvents() {
        return this.currentEventsDsService.getAllEvents().pipe(
            tap((users) => {
                this._currentEvents.next(users);
            }),
        );
    }

    /**
     * Get the current logged in user data
     */
    get(): Observable<any> {
        return this._accessService.loggedUser();
    }

    getCurrentEventDetail(id: number | string): Observable<ItemResource | null> {
        return this.currentEventsDsService.getEventById(String(id)).pipe(
            catchError((error) => {
                console.error(error);
                return of(null);
            }),
        );
    }
}
